import React, { useState, useEffect, createContext } from 'react';

export const CommentsContext = createContext();

export const CommentsStorage = ({ children }) => {
  const [challenge_id] = useState(window.location.pathname.split('/')[2].split('-')[0]);
  const [list, setList] = useState([]);
  const [input, setInput] = useState('');
  const [_token] = useState(document.querySelector('[name="csrf-token"]').content);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(false);
  const [emojiBoxActive, setEmojiBoxActive] = useState(false);

  useEffect(() => {
    async function loadData() {
      try {
        const res = await fetch(`/comments/challenge/${challenge_id}/page/${currentPage}`);
        const data = await res.json();
        setList(data.data);
        data.last_page == 1 || !data.last_page ? setLastPage(true) : setLastPage(false);
      } catch (error) {
        console.log(error);
      }
    }
    loadData();
  }, [currentPage]);

  const handleSubmit = async () => {
    if (input.length) {
      const res = await fetch(`/comments/challenge/${challenge_id}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ description: input, _token: _token }),
      });

      const data = await res.json();

      setList(value => [...data, ...value]);

      setInput('');
      setEmojiBoxActive(false);
    }
  };

  return (
    <CommentsContext.Provider
      value={{
        list,
        input,
        setInput,
        handleSubmit,
        currentPage,
        setCurrentPage,
        lastPage,
        emojiBoxActive,
        setEmojiBoxActive,
      }}
    >
      {children}
    </CommentsContext.Provider>
  );
};
